import { render, staticRenderFns } from "./PlayersPendingAddForVip.vue?vue&type=template&id=41d201c4&"
import script from "./PlayersPendingAddForVip.vue?vue&type=script&lang=js&"
export * from "./PlayersPendingAddForVip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports